import React, { useEffect, useState } from "react";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";
import ServiceCard from "./components/ServiceCard";
import { Tab, Tabs, Modal, Button, Form } from "react-bootstrap";
import { ServiceHelper } from "@/app/core/util/helpers/ServiceHelper";

export default function ServicesControlPanel() {
    const [services, setServices] = useState([]);
    const [rawServices, setRawServices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentService, setCurrentService] = useState(null);
    const [formData, setFormData] = useState({ name: "", price: "", description: "", status: ServiceHelper.Status.Active });

    useEffect(() => {
        loadServices();
    }, []);

    async function loadServices() {
        let servicesResp = await ServicesController.ListAll();
        servicesResp.sort((a, b) => b.createdDate.seconds - a.createdDate.seconds);

        setServices(servicesResp);
        setRawServices(servicesResp);
    }

    function handleChange(evt) {
        const inputValue = evt.target.value.toLowerCase();
        if (inputValue === "") {
            setServices(rawServices);
            return;
        }

        let newResults = [];
        for (let item of rawServices) {
            const name = item.name?.toLowerCase();
            const description = item.description?.toLowerCase();
            if (name.includes(inputValue) || description.includes(inputValue)) {
                newResults.push(item);
            }
        }
        setServices(newResults);
    }

    function handleFormChange(evt) {
        const { name, value } = evt.target;
        setFormData({ ...formData, [name]: value });
    }

    function handleAdd() {
        setCurrentService(null);
        setFormData({ name: "", price: "", description: "", status: ServiceHelper.Status.Active });
        setShowModal(true);
    }

    function handleEdit(service) {
        setCurrentService(service);
        setFormData({ 
            name: service.name, 
            price: service.price, 
            description: service.description, 
            status: service.status || ServiceHelper.Status.Active 
        });
        setShowModal(true);
    }

    async function handleSubmit() {
        if (!formData.name || !formData.price || !formData.description || !formData.status) {
            alert("Todos os campos são obrigatórios.");
            return;
        }

        const serviceData = {
            ...formData,
            price: Number(formData.price),
            currency: "BRL",
            updatedDate: new Date(),
        };

        if (currentService) {
            serviceData.id = currentService.id;
            await ServicesController.Update(serviceData);
        } else {
            serviceData.createdDate = new Date();
            await ServicesController.Add(serviceData);
        }

        setShowModal(false);
        loadServices();
    }

    return (
        <>
            <div className="content">
                <div className="row">
                    <div className="col-md-6">
                        <div className="content-heading">
                            <h3>Serviços</h3>
                        </div>
                    </div>
                    <div className="col-md-6 row">
                        <div className="form-group col-md-8">
                            <div className="input-group mt-3">
                                <input
                                    type="text"
                                    onChange={(evt) => handleChange(evt)}
                                    className="form-control form-control"
                                    placeholder="Pesquisar..."
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text border-0 bg-body">
                                        <i className="fa fa-fw fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-4">
                            <button className="btn btn-primary mt-3" onClick={handleAdd}>
                                Adicionar Serviço
                            </button>
                        </div>
                    </div>
                    <div className="col-12">
                        <Tabs defaultActiveKey={1}>
                            <Tab eventKey={1} title={services && `(${services.length}) Serviços`}>
                                {services && services.map(item => (
                                    <ServiceCard data={item} reload={() => loadServices()} onEdit={() => handleEdit(item)} />
                                ))}
                            </Tab>
                            {/* <Tab eventKey={2} title={deletedServices && `(${deletedServices.length}) Excluídos`}>
                                {deletedServices && deletedServices.map(item => (
                                    <ServiceCard data={item} reload={() => loadServices()} onEdit={() => handleEdit(item)} />
                                ))}
                            </Tab> */}
                        </Tabs>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{currentService ? "Editar Serviço" : "Adicionar Serviço"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleFormChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formPrice">
                            <Form.Label>Preço</Form.Label>
                            <Form.Control
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleFormChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDescription">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={formData.description}
                                onChange={handleFormChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formStatus">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                                as="select"
                                name="status"
                                value={formData.status}
                                onChange={handleFormChange}
                                required
                            >
                                <option value={ServiceHelper.Status.Active}>Ativo</option>
                                <option value={ServiceHelper.Status.Inactive}>Inativo</option>
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
